import axios from 'axios'

export const UserCompanyGroupApi = {
    list: (userEmail) => axios.get(`/web/company-groups/user-company-groups/${userEmail}`)
}
